export default __webpack_public_path__ + "static/media/banner-min.0875057b.webp";